<template>
  <div
    class="checkbox-wrap"
  >
    <van-checkbox
      v-if="item.required"
      class="checkbox"
      :model-value="!!submitValue?.value"
      shape="square"
      icon-size="16px"
      :checked-color="themeColor"
      :disabled="readonly"
      @update:modelValue="onValueChange"
    ></van-checkbox>
    <div class="checkbox-text" v-html="item.text">
    </div>
  </div>
</template>

<script>
import { Checkbox } from 'vant';

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  computed: {
    themeColor() {
      return this.$store.state.formConfig.theme_color;
    },
  },
  components: {
    [Checkbox.name]: Checkbox
  },
  methods: {
    // 【1】值监听；无参数调用用于提交前同步当前值
    onValueChange(checked = !!this.submitValue?.value) {
      this.$emit('change', {
        value: checked ? 1 : 0
      });
    }
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.checkbox-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .checkbox {
    --van-checkbox-border-color: #000000;
    flex-shrink: 0;
    margin-right: 8px;
    margin-top: 2px;
  }
  .checkbox-text {
    flex: 1;
    min-width: 0;
    font-size: @font-size-4;
    line-height: 20px;
    color: @desc-color-1;
    overflow-wrap: anywhere;
    white-space: pre-line;
  }
}
</style>
